<template>
  <div>
    <div class="card" v-if="loading">
      <div class="card-body">
        <div class="text-center">
          <b-spinner class="ms-2" variant="primary"></b-spinner>
        </div>
      </div>
    </div>

    <div class="filtro-component" v-if="!loading">
      <b-card>
        <div
          class="row cursor-pointer"
          id="header-filtro"
          @click="filtroExpandido = !filtroExpandido"
        >
          <div
            class="col-md-6 col-sm-12 d-flex flex-column flex-md-row mb-2 mb-md-0 order-2 order-md-1 align-items-center"
          >
            <h4
              class="font-size-16 mb-0 text-uppercase"
              style="font-weight: 600"
            >
              Filtro de Clientes Rurais
            </h4>
          </div>

          <div
            class="col-md-6 col-sm-12 d-flex flex-column flex-md-row justify-content-md-end order-1 order-md-2 mb-2 mb-md-0"
          >
            <div class="d-flex">
              <b-button
                variant="success"
                class="me-2"
                @click="redirectToCadastroEdicao"
              >
                <i class="fa fa-solid fa-plus me-2"></i>
                <span>Novo Cliente</span>
              </b-button>
              <div>
                <i
                  :class="
                    filtroExpandido
                      ? 'mdi mdi-filter'
                      : 'mdi mdi-filter-outline'
                  "
                  class="icone-accordion"
                ></i>
              </div>
            </div>
          </div>
        </div>

        <b-collapse v-model="filtroExpandido" class="mt-3">
          <div class="row">
            <div class="col-md-3">
              <b-form-group
                label="Cooperado"
                :state="getState('selecaoCooperado')"
                invalid-feedback="O campo cooperado é obrigatório"
              >
                <multiselect
                  label="name"
                  track-by="name"
                  select-label=""
                  :taggable="false"
                  :max-height="200"
                  :allowEmpty="false"
                  placeholder="Selecione um Cooperado"
                  :options="cooperadoLkp"
                  v-model="selecaoCooperadoVM"
                  @input="carregarClienteRural"
                >
                  <span slot="noOptions">Nenhum Cooperado disponível</span>
                </multiselect>
              </b-form-group>
            </div>
            <div class="col-md-3">
              <b-form-group label="Cliente Rural">
                <multiselect
                  label="name"
                  track-by="name"
                  select-label=""
                  :max-height="200"
                  placeholder="Selecione"
                  :options="clienteRuralLkp"
                  v-model="selecaoClienteRuralVM"
                  :loading="loadingClienteRural"
                  invalid-feedback="Campo obrigatório"
                >
                  <span slot="noOptions">Nenhum Cliente Rural disponível</span>
                </multiselect>
              </b-form-group>
            </div>
            <div class="col-md-3">
              <b-form-group class="mb-3" label="CPF / CNPJ">
                <multiselect
                  label="cpfCnpj"
                  :max-height="200"
                  track-by="cpfCnpj"
                  placeholder="Selecione"
                  v-model="selecaoCpfCnpjVM"
                  v-mask="'###.###.###-##'"
                  :options="filteredOptions"
                  :custom-label="formatCpfCnpj"
                  @search-change="updateSearch"
                />
              </b-form-group>
            </div>
            <div class="col-md-3">
              <b-form-group label="Mês Aniversário">
                <multiselect
                  v-model="mesAnoVM"
                  :options="mes"
                  label="label"
                  track-by="value"
                  placeholder="Selecione o mês"
                ></multiselect>
              </b-form-group>
            </div>
          </div>

          <div class="row align-items-center">
            <div class="col-md-3">
              <b-form-group class="mb-3" label="Email">
                <b-form-input v-model.trim="emailVM" type="text" />
              </b-form-group>
            </div>
            <div class="col-md-3">
              <b-form-group class="mb-3" label="Municipio - UF">
                <multiselect
                  label="name"
                  track-by="name"
                  :searchable="true"
                  :show-labels="false"
                  :allow-empty="false"
                  placeholder="Selecione"
                  v-model="selecaoMunicipioVM"
                  :options="selecaoMunicipioLkp"
                />
              </b-form-group>
            </div>
            <div class="col-md-3">
              <b-form-group class="mb-3" label="Projeto Unicampo">
                <multiselect
                  label="name"
                  track-by="name"
                  :searchable="true"
                  :show-labels="false"
                  :allow-empty="false"
                  placeholder="Selecione"
                  v-model="selecaoProjetoVM"
                  :options="selecaoProjetoLkp"
                />
              </b-form-group>
            </div>
            <div class="col-md-3">
              <b-form-group class="mb-3" label="Safra">
                <multiselect
                  v-model="selecaoSafraVM"
                  :options="selecaoSafraLkp"
                  placeholder="Selecione"
                  :searchable="true"
                  :show-labels="false"
                  :allow-empty="false"
                  label="name"
                  track-by="name"
                />
              </b-form-group>
            </div>
          </div>

          <div class="row">
            <div
              class="col-12 d-flex justify-content-between align-items-center"
            >
              <div class="d-flex">
                <b-button class="me-2" @click="limparFormulario">
                  <i class="mdi mdi-broom align-middle me-1"></i>
                  Limpar
                </b-button>
                <b-button
                  variant="primary"
                  class="me-2"
                  @click="emitirFiltro"
                  :disabled="disabledFiltro"
                >
                  <i class="mdi mdi-filter-outline align-middle me-1"></i>
                  Filtrar
                  <b-spinner
                    variant="secondary"
                    small
                    class="ms-2"
                    v-if="disabledFiltro"
                  ></b-spinner>
                </b-button>
              </div>
            </div>
          </div>
        </b-collapse>
      </b-card>
    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import { required } from "vuelidate/lib/validators";
import clienteRuralMixin from "@/tools/mixins/clienteRuralMixin.js";
import { filtrosClientesRuraisHelper } from "@/store/helpers/vuex/astec";

const MESES_DO_ANO = [
  { value: 1, label: "Janeiro" },
  { value: 2, label: "Fevereiro" },
  { value: 3, label: "Março" },
  { value: 4, label: "Abril" },
  { value: 5, label: "Maio" },
  { value: 6, label: "Junho" },
  { value: 7, label: "Julho" },
  { value: 8, label: "Agosto" },
  { value: 9, label: "Setembro" },
  { value: 10, label: "Outubro" },
  { value: 11, label: "Novembro" },
  { value: 12, label: "Dezembro" }
];

export default {
  name: "FiltroClientesRurais",
  mixins: [clienteRuralMixin],
  props: {
    redirectToCadastroEdicao: Function
  },
  components: {
    Multiselect
  },

  data() {
    return {
      loading: true,
      mes: MESES_DO_ANO,
      searchQuery: "",
      submit: false,
      cdPessoa: "",
      disabledFiltro: false,
      filtroExpandido: true,
      loadingClienteRural: false,

      cooperadoLkp: [],
      clienteRuralLkp: [],
      selecaoMunicipioLkp: [],
      selecaoProjetoLkp: [],
      selecaoSafraLkp: []
    };
  },

  computed: {
    ...filtrosClientesRuraisHelper({
      state: [
        "selecaoCooperado",
        "selecaoClienteRural",
        "selecaoCpfCnpj",
        "mesAno",
        "email",
        "selecaoMunicipio",
        "selecaoProjeto",
        "selecaoSafra"
      ],
      getters: ["filtroClientesRurais", "hasFiltrosAtivos"],
      actions: []
    }).computed,

    selecaoCooperadoVM: {
      get() {
        return this.selecaoCooperado;
      },
      set(val) {
        this.setFiltroCampo({ campo: "selecaoCooperado", valor: val });
      }
    },

    selecaoClienteRuralVM: {
      get() {
        return this.selecaoClienteRural;
      },
      set(val) {
        this.setFiltroCampo({ campo: "selecaoClienteRural", valor: val });
      }
    },

    selecaoCpfCnpjVM: {
      get() {
        return this.selecaoCpfCnpj;
      },
      set(val) {
        this.setFiltroCampo({ campo: "selecaoCpfCnpj", valor: val });
      }
    },

    mesAnoVM: {
      get() {
        return this.mesAno;
      },
      set(val) {
        this.setFiltroCampo({ campo: "mesAno", valor: val });
      }
    },

    emailVM: {
      get() {
        return this.email;
      },
      set(val) {
        this.setFiltroCampo({ campo: "email", valor: val });
      }
    },

    selecaoMunicipioVM: {
      get() {
        return this.selecaoMunicipio;
      },
      set(val) {
        this.setFiltroCampo({ campo: "selecaoMunicipio", valor: val });
      }
    },

    selecaoProjetoVM: {
      get() {
        return this.selecaoProjeto;
      },
      set(val) {
        this.setFiltroCampo({ campo: "selecaoProjeto", valor: val });
      }
    },

    selecaoSafraVM: {
      get() {
        return this.selecaoSafra;
      },
      set(val) {
        this.setFiltroCampo({ campo: "selecaoSafra", valor: val });
      }
    },

    filteredOptions() {
      if (!this.searchQuery) return this.clienteRuralLkp;
      const normalizedSearch = this.normalizeCpfCnpj(this.searchQuery);

      return this.clienteRuralLkp.filter(option => {
        const normalizedOption = this.normalizeCpfCnpj(option.cpfCnpj);
        return normalizedOption.includes(normalizedSearch);
      });
    }
  },

  methods: {
    ...filtrosClientesRuraisHelper({
      state: [],
      getters: [],
      actions: [
        "setFiltroClientesRurais",
        "setFiltroCampo",
        "setOpcoesFiltro",
        "limparFiltrosClientesRurais"
      ]
    }).methods,

    getState(param) {
      if (this.submit) {
        return !this.$v[param].$invalid;
      }
      return null;
    },

    async buscarDados() {
      await this.buscarLkpSafra();
      await this.getNomeRazaoUsuario();
      await this.buscarMunicipioUf();
      await this.buscarLkpProjeto();
      await this.buscarLkpCooperado();
      await this.carregarClienteRural();
      await this.verificarCooperado();
      this.loading = false;

      if (this.hasFiltrosAtivos) {
        await this.carregarFiltrosDoVuex();
      }
    },

    async carregarFiltrosDoVuex() {
      if (this.selecaoCooperado) {
        await this.carregarClienteRural();
        if (this.selecaoClienteRural) {
          const clienteEncontrado = this.clienteRuralLkp.find(
            cliente => cliente.value === this.selecaoClienteRural.value
          );
          if (clienteEncontrado) {
            this.selecaoCpfCnpj = clienteEncontrado;
          }
        }
      }
    },

    async carregarClienteRural() {
      if (this.selecaoCooperado) {
        this.clienteRuralLkp = [];
        this.loadingClienteRural = true;
        try {
          const response = await this.$http.get(
            "/api/astec/getLkpClienteRuralProjetos/" +
              this.selecaoCooperado.value
          );
          this.clienteRuralLkp = response.data.map(cliente => {
            return {
              name: cliente.DISPLAY,
              value: cliente.ID,
              cpfCnpj: cliente.NRCPFCNPJ
            };
          });

          if (
            this.selecaoClienteRural &&
            !this.clienteRuralLkp.find(
              c => c.value === this.selecaoClienteRural.value
            )
          ) {
            this.selecaoClienteRural = null;
            this.selecaoCpfCnpj = null;
          }
        } catch (err) {
          this.$tools.alerta(err.response.data.message, "error");
        }
        this.loadingClienteRural = false;
      }
    },

    async verificarFiltro(filtro) {
      this.selecaoCooperado = this.cooperadoLkp.find(
        el => el.value == filtro.cdCooperado
      );
      if (this.selecaoCooperado) {
        this.setFiltroCampo({
          campo: "selecaoCooperado",
          valor: this.selecaoCooperado
        });
      }

      await this.carregarClienteRural();
      if (filtro.sqCliente) {
        this.selecaoClienteRural = this.clienteRuralLkp.find(
          el => el.value == filtro.sqCliente
        );
        this.selecaoCpfCnpj = this.selecaoClienteRural;
      }

      this.mesAno =
        this.mes.find(el => el.value == filtro.mes_aniversario) || null;
      this.email = filtro.e_mail || "";
      this.selecaoMunicipio = this.selecaoMunicipioLkp.find(
        el => el.value == filtro.sq_regiao
      );
      this.selecaoProjeto = this.selecaoProjetoLkp.find(
        el => el.value == filtro.cd_projeto
      );
      this.selecaoSafra = this.selecaoSafraLkp.find(
        el => el.name == filtro.safra
      );

      const filtrosParaSalvar = {
        selecaoCooperado: this.selecaoCooperado,
        selecaoClienteRural: this.selecaoClienteRural,
        selecaoCpfCnpj: this.selecaoCpfCnpj,
        mesAno: this.mesAno,
        email: this.email,
        selecaoMunicipio: this.selecaoMunicipio,
        selecaoProjeto: this.selecaoProjeto,
        selecaoSafra: this.selecaoSafra
      };

      this.setFiltroClientesRurais(filtrosParaSalvar);
      this.emitirFiltro();
    },

    async verificarCooperado() {
      if (this.cooperadoLkp.length === 1) {
        this.selecaoCooperadoVM = this.cooperadoLkp[0];
        // Salva no Vuex
        if (this.selecaoCooperado) {
          this.setFiltroCampo({
            campo: "selecaoCooperado",
            valor: this.selecaoCooperado
          });
        }
      }
    },

    FiltrarClientesRurais() {
      const dados = {
        cdCooperado: this.selecaoCooperado ? this.selecaoCooperado.value : null,
        sqCliente:
          this.selecaoClienteRural?.value || this.selecaoCpfCnpj?.value || null,
        mes_aniversario: this.mesAno ? this.mesAno.value : "",
        e_mail: this.email ? this.email.trim() : "",
        sq_regiao: this.selecaoMunicipio ? this.selecaoMunicipio.value : null,
        cd_projeto: this.selecaoProjeto ? this.selecaoProjeto.value : null,
        safra: this.selecaoSafra ? this.selecaoSafra.name : null
      };
      return dados;
    },

    emitirFiltro() {
      this.submit = true;
      this.$v.$touch();

      if (this.$v.$invalid) {
        return;
      }
      const filtro = this.FiltrarClientesRurais();
      this.disabledFiltro = true;
      this.$store.commit("PARAMETROS_FILTRO_CLIENTE_RURAL_ASTEC", filtro);

      this.$emit("clientesRuraisFiltrados", filtro, () => {
        this.disabledFiltro = false;
        this.filtroExpandido = true;
      });
    },

    limparFormulario() {
      this.limparFiltrosClientesRurais();
      this.searchQuery = "";
      this.clienteRuralLkp = [];
      this.loadingClienteRural = false;

      this.submit = false;
      this.$v.$reset();

      this.$emit("clientesRuraisFiltrados", {}, () => {
        this.disabledFiltro = false;
      });
    },

    formatCpfCnpj(option) {
      return option.cpfCnpj;
    },

    normalizeCpfCnpj(value) {
      if (!value) return "";
      return value.replace(/\D/g, "");
    },

    updateSearch(query) {
      this.searchQuery = query;
    }
  },

  validations: {
    selecaoCooperado: { required }
  },

  async mounted() {
    await this.buscarDados();
    if (this.$store.state.filtroClienteRuralAstec) {
      await this.verificarFiltro(this.$store.state.filtroClienteRuralAstec);
    }
  }
};
</script>

<style scoped>
.icone-accordion {
  font-size: 24px;
}
</style>
